export default "__VITE_ASSET___VK9kRR0__"